import { Column} from 'react-table'
import { ApplicationReviewNotesCell, ApplicationReviewNotesHeader } from '../components';
import { ApplicationReview } from '../../../_models'
import { ApplicationStateCell, ShowDateCell } from '../../../../../../components/widgets';
import { ApplicationReviewUserActionsCell, ApplicationReviewUserReassignCell } from '../../../../../setsco/workflow/submit-inspection-modal/components';
import { PropsWithNotes } from '../../../../../../components/table';
import { KTSVG } from '../../../../../../../_metronic/helpers';
import { useViewDraftPopupState } from '../../../../../setsco/workflow/components/ViewDraftPopup';
import { useMemo } from 'react';
import { useAuth } from '../../../../../auth';


const ViewDraftButton = ({row} : {row: ApplicationReview }) => {

  const { hasRole } = useAuth();
  const { toggleShow, setDetails } = useViewDraftPopupState(state => state);
  const { type, state, draft } = row;

  const details: Record<string, any> | null = useMemo(() => {
    if (! draft) return null;
    try {
      const details = JSON.parse(draft);
      return details;
    } catch (error) {
      console.error("Failed to parse draft JSON", draft);
    }
    return null;
  }, [draft]);

  if (! (hasRole('CAMS Admin') && type === "Sampling" && state === "Inspection - Sampling" && details)) {
    return null;
  }

  return (
    <button type="button" className="btn btn-icon btn-active-color-primary btn-sm p-0 h-15px w-15px"
      onClick={() => {
        setDetails(details);
        toggleShow(true);
      }}
      title="View Draft"
    >
      <KTSVG path='/media/icons/duotune/files/fil024.svg' className='svg-icon-0 m-0' />
    </button>
  );
}

export const ApplicationReviewUserColumns: ReadonlyArray<Column<PropsWithNotes<ApplicationReview>>> = [
  {
    Header: 'Type',
    minWidth: 80,
    accessor: 'type',
  },
  {
    Header: 'Actions',
    minWidth: 125,
    id: 'actions',
    Cell: ({...props}) => <ApplicationReviewUserActionsCell review={props.data[props.row.index]} />,
  },
  {
    Header: <ApplicationReviewNotesHeader />,
    minWidth: 20,
    id: 'notes',
    Cell: ({...props}) => <ApplicationReviewNotesCell row={props.data[props.row.index]} />,
  },
  {
    Header: 'State',
    minWidth: 225,
    accessor: 'state',
    Cell: ({...props}) =>
    <div className="d-flex flex-row align-items-center gap-1">
      <ApplicationStateCell state_val={props.data[props.row.index].state} className="min-w-225px" />
      <ViewDraftButton row={props.data[props.row.index]} />
    </div>
  },
  {
    Header: '',
    minWidth: 20,
    id: 'reassign',
    Cell: ({...props}) => <ApplicationReviewUserReassignCell review={props.data[props.row.index]} />,
  },
  {
    Header: 'Assigned To',
    minWidth: 125,
    accessor: 'assignedTo',
    Cell: ({...props}) =>
    <div className="">
    { (props.data[props.row.index]?.assignedTo && props.data[props.row.index].assignedTo?.name) &&
      props.data[props.row.index].assignedTo.name
    }
    </div>
  },
  {
    Header: 'Assigned Inspector',
    minWidth: 125,
    accessor: 'assignedInspector',
    Cell: ({...props}) =>
    <div className="">
    { (props.data[props.row.index]?.assignedInspector && props.data[props.row.index].assignedInspector?.name) &&
      props.data[props.row.index].assignedInspector.name
    }
    </div>
  },
  {
    Header: 'Last Update',
    minWidth: 125,
    accessor: 'dteUpd',
    Cell: ({...props}) => <ShowDateCell date_val={props.data[props.row.index].dteUpd} />,
  },
];
